const sectionStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "60px 20px"
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "20px",
  background: "#fff",
  boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
  transition: "all 0.2s ease"
};

const hoverEffect = (e, enter = true) => {
  e.currentTarget.style.boxShadow = enter
    ? "0 15px 35px rgba(0,0,0,0.1)"
    : "0 10px 25px rgba(0,0,0,0.05)";
  e.currentTarget.style.transform = enter
    ? "translateY(-3px)"
    : "translateY(0)";
};

const AwsDataEngineer = () => {
  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px" }}>
        <h1 style={{ fontSize: "36px", marginBottom: "20px" }}>
          Building Scalable Data Platforms on AWS
        </h1>

        <p style={{ fontSize: "18px", color: "#555", maxWidth: "700px" }}>
          With the AWS Certified Data Engineer – Associate certification, I’m expanding my capabilities
          in designing reliable, scalable, and production-ready data solutions on AWS.
        </p>
      </div>


      {/* IMAGE */}
      <div style={{ ...sectionStyle, paddingTop: "0", textAlign: "center" }}>
        <img
          src="/images/awsDataEngineerBadge.png"
          alt="AWS Certified Data Engineer Associate"
          style={{
            width: "100%",
            maxWidth: "280px",
            borderRadius: "12px",
            boxShadow: "0 15px 40px rgba(0,0,0,0.15)"
          }}
        />

        <div style={{ fontSize: "14px", color: "#777", marginTop: "10px" }}>
          AWS Certified Data Engineer – Associate
        </div>
      </div>


      {/* INTRO */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          This certification strengthens my ability to build end-to-end data pipelines and
          design architectures that transform raw data into actionable insights.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          My focus is on practical implementation — creating systems that are scalable,
          maintainable, and aligned with real business needs.
        </p>
      </div>


      {/* CAPABILITIES 🔥 */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "25px" }}>
          Data Engineering Capabilities I Can Deliver
        </h2>

        <div style={gridStyle}>
          {[
            "Designing end-to-end data pipelines from ingestion to analytics",
            "Building scalable ETL/ELT workflows using AWS Glue and Lambda",
            "Designing data lakes on Amazon S3 with efficient partitioning strategies",
            "Implementing event-driven data processing pipelines",
            "Handling batch and near real-time data processing scenarios",
            "Designing storage strategies using S3, DynamoDB, and optimized schemas",
            "Preparing datasets for analytics, reporting, and AI workloads",
            "Optimizing data pipelines for performance and cost efficiency",
            "Ensuring reliability, monitoring, and fault tolerance in data systems"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              ✓ {item}
            </div>
          ))}
        </div>
      </div>


      {/* USE CASES 🔥 */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "25px" }}>
          Where This Creates Real Value
        </h2>

        <div style={gridStyle}>
          {[
            "Building data platforms for reporting and business intelligence",
            "Designing pipelines for processing application and event data",
            "Creating data foundations for AI and machine learning systems",
            "Automating data ingestion from multiple external sources",
            "Transforming raw data into structured, analytics-ready datasets",
            "Replacing manual data workflows with automated pipelines"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* ARCHITECTURE POSITIONING */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          Data engineering is not just about moving data — it’s about designing systems that
          ensure consistency, scalability, and long-term maintainability.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          I approach data architectures with the same principles as application systems:
          clear data flows, well-defined responsibilities, and efficient resource usage.
        </p>
      </div>


      {/* CTA 🔥 */}
      <div style={{
        textAlign: "center",
        margin: "80px 0",
        padding: "50px 20px",
        background: "#fafafa"
      }}>
        <h2 style={{ marginBottom: "15px" }}>
          Build a Scalable Data Platform on AWS
        </h2>

        <p style={{ color: "#555", marginBottom: "25px" }}>
          Let’s design data pipelines and architectures tailored to your business needs.
        </p>

        <a
          href="/contact"
          style={{
            display: "inline-block",
            padding: "14px 32px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "500",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
          }}
        >
          Discuss Your Data Architecture →
        </a>
      </div>

    </div>
  );
};

export default AwsDataEngineer;